import TagSortDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tags/index.js?vue3';
import initDeleteTagModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/tags/init_delete_tag_modal.js?vue3';
import initIssuablePopovers from '/builds/gitlab/gitlab-ee/app/assets/javascripts/issuable/popover/index.js?vue3';

initDeleteTagModal();
TagSortDropdown();
initIssuablePopovers(document.querySelectorAll('[data-reference-type="commit"]'));
